require('./bootstrap');

import Vue from 'vue/dist/vue';
import VueAxios from 'vue-axios';
import axios from 'axios';

window.Vue = require('vue').default;
window.events = new Vue();
window.flash = function(message,type) {
    window.events.$emit('flash',message, type);
}

Vue.config.productionTip = false;

Vue.component('transfer-component', require('./components/TransferComponent.vue').default);
Vue.component('files-component', require('./components/FilesComponent.vue').default);
Vue.component('file-component', require('./components/FileComponent.vue').default);
Vue.component('search-component', require('./components/SearchComponent.vue').default);
Vue.component('search-result-component', require('./components/SearchResultComponent.vue').default);
Vue.component('premium-component', require('./components/PremiumComponent.vue').default);
Vue.component('premium-free-component', require('./components/PremiumFreeComponent.vue').default);
Vue.component('account-settings-component', require('./components/AccountSettingsComponent.vue').default);
Vue.component('login-component', require('./components/LoginComponent.vue').default);
Vue.component('register-component', require('./components/RegisterComponent.vue').default);
Vue.component('reset-component', require('./components/ResetComponent.vue').default);
Vue.component('flash', require('./components/FlashComponent.vue').default);


Vue.use(VueAxios, axios);

Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
             title: binding.value,
             placement: binding.arg,
             trigger: 'hover'             
         })
})


const app = new Vue({
    el: '#magicnzb_app',
});


const search = new Vue({
    el: '#search',
});